import type { TimeOffGranularity } from "@/server-types";

/** What a type with no emoji of its own shows, in the picker as on its tile. */
export function fallbackTimeOffEmoji(granularity: TimeOffGranularity): string {
  return granularity === "DAY" ? "🏖️" : "⏸️";
}

/**
 * A curated grid rather than a full emoji-picker library — no such dependency
 * exists in this repo yet (checked), and `StaffTimeOffType.emoji` only ever
 * needs to label a handful of absence/carve-out categories, not arbitrary text.
 */
export const TIME_OFF_TYPE_EMOJIS = [
  "🏖️",
  "🤒",
  "🩹",
  "🤕",
  "🤧",
  "🚑",
  "👶",
  "🤱",
  "🎓",
  "📌",
  "🍽️",
  "☕",
  "🚬",
  "🚶",
  "🧘",
  "🏋️",
  "🚗",
  "🏠",
  "✈️",
  "🎉",
  "🎂",
  "⚖️",
  "🪖",
  "🧑‍🏫",
  "🧑‍💼",
  "🛠️",
  "📚",
  "🌙",
  "☀️",
  "⭐",
] as const;
